// Libraries
var React = require("react");
var debounce = require('lodash/debounce');

// Components
var Icon = require('../../common/Icon/Icon.js');
var spursLogo = require('./spurs-logo.svg');

// Style
require("./Information.scss");

class InformationModule extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      backgroundImage: ''
    }

  }

  componentDidMount() {
    this.setBackgroundImage();
    window.addEventListener('resize', debounce(() => { this.setBackgroundImage(); }, 250));
  }

  setBackgroundImage() {
    let backgroundImage = window.matchMedia('(min-width: 660px)').matches ? this.props.data.desktopBackground.extraLargeUrl : this.props.data.mobileBackground.smallUrl;
    if(!backgroundImage) {
      backgroundImage = this.props.data.desktopBackground.extraLargeUrl;
    }
    this.setState({
      backgroundImage: backgroundImage
    });
  }

  render() {
    const additionalInformationClass = this.props.data.isOneHotspur ? ' c-information--one-hotspur c-section--one-hotspur' : this.props.data.isPremium ? ' c-information--premium' : '';
    const buttonInformationClass = this.props.data.isOneHotspur ? ' c-button--one-hotspur'  : this.props.data.isPremium ? ' c-button--premium' : 'c-button--outline';

    return (
      <div
        id={this.props.data.id}
        className={`c-information c-section c-section--always-padded  ${additionalInformationClass}`}
        style={
          {
            backgroundImage: 'url(' + this.state.backgroundImage + ')'
          }
        }
      >
        {this.props.data.showSpursLogo ? 
          <div className="c-information__logo">
            <img src={spursLogo} alt="Spurs" className="c-information__logo-asset" width={72} height={178} />
          </div>
        : null}
        
        <div className="c-section__inner">
          <div className="c-information__inner"> 
            <div className="c-information__quick-links-container">           
              {this.props.data.quickLinks.length > 0 ?
              <ul className="c-information__quick-links">
                {this.props.data.quickLinks.length > 0 && this.props.data.quickLinks.map((item, index) => {
                  return(
                    <li key={index} className="c-information__quick-links-item">
                      <a href={item.link.url} className="c-information__quick-links-link">
                        <Icon className="c-information__quick-links-icon" name={item.icon} width={30} height={30} />
                        <Icon className="c-information__quick-links-chevron" name="chevronRight" width={7} height={12} />
                        {item.link.caption}
                      </a>
                    </li>
                  );
                })}
              </ul>
              : null}
            </div>
            
            <div className="c-information__text-container">     
              <h2 className="c-information__title">{this.props.data.title}</h2>
              <div className="c-information__text c-richtext">
                <p>{this.props.data.text}</p>
              </div>
              
              {this.props.data.cta && this.props.data.cta.url && this.props.data.cta.caption ?
                <a href={this.props.data.cta.url} className={`c-button c-button--on-dark ${buttonInformationClass}`}>{this.props.data.cta.caption}</a>
              : null}
            </div>

          </div>
        </div>
      </div>
    );
  }
}

module.exports = InformationModule;



// WEBPACK FOOTER //
// ./src/components/Information/InformationModule.js